import React from "react";
import { useParams, Navigate } from "react-router-dom";
import PolicyPage from "../components/PolicyPage";
import { getPolicyBySlug } from "../lib/policyContent";

export default function PolicyRoute() {
  const { slug } = useParams();
  const policy = getPolicyBySlug(slug);
  if (!policy) return <Navigate to="/legal" replace />;
  return <PolicyPage policy={policy} />;
}
